import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { RequireLoggedOut } from "@/app/router";
import { QuestionnaireLayout } from "../components";
import {
  Checkout,
  ContactDetails,
  Intake,
  Measurements,
  PersonalDetails,
  PersonalInfo,
  Product,
} from "../screens";
import { QUESTIONNAIRE_ROUTE } from "./constants";

export const getQuestionnaireRoute = (): RouteObject => ({
  path: QUESTIONNAIRE_ROUTE.BASE,
  element: (
    <RequireLoggedOut>
      <QuestionnaireLayout />
    </RequireLoggedOut>
  ),
  children: [
    { path: QUESTIONNAIRE_ROUTE.MEASUREMENTS, element: <Measurements /> },
    { path: QUESTIONNAIRE_ROUTE.PERSONAL_INFO, element: <PersonalInfo /> },
    { path: QUESTIONNAIRE_ROUTE.INTAKE, element: <Intake /> },
    {
      path: QUESTIONNAIRE_ROUTE.PERSONAL_DETAILS,
      element: <PersonalDetails />,
    },
    { path: QUESTIONNAIRE_ROUTE.CONTACT_DETAILS, element: <ContactDetails /> },
    { path: QUESTIONNAIRE_ROUTE.PRODUCT, element: <Product /> },
    { path: QUESTIONNAIRE_ROUTE.CHECKOUT, element: <Checkout /> },
    {
      index: true,
      element: <Navigate replace to={QUESTIONNAIRE_ROUTE.MEASUREMENTS} />,
    },
    {
      path: "*",
      element: <Navigate replace to={QUESTIONNAIRE_ROUTE.MEASUREMENTS} />,
    },
  ],
});
